module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "toggle-button",
      "name": "ToggleButton"
    }
  }, [_c('div', {
    staticClass: "bs-example form-group"
  }, [_c('h4', [_vm._v("ToggleButton")]), _vm._v(" "), _c('p', [_vm._v("A 2 states button (single true/false) but with a better looking.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('toggle-button', {
    model: {
      value: (_vm.one),
      callback: function($$v) {
        _vm.one = $$v
      },
      expression: "one"
    }
  }, [_vm._v("One")]), _vm._v(" "), _c('toggle-button', {
    model: {
      value: (_vm.two),
      callback: function($$v) {
        _vm.two = $$v
      },
      expression: "two"
    }
  }, [_vm._v("Two")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "true-type": "info",
      "disabled": ""
    },
    model: {
      value: (_vm.two),
      callback: function($$v) {
        _vm.two = $$v
      },
      expression: "two"
    }
  }, [_vm._v("Two (disabled)")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "false-type": "warning",
      "readonly": ""
    },
    model: {
      value: (_vm.two),
      callback: function($$v) {
        _vm.two = $$v
      },
      expression: "two"
    }
  }, [_vm._v("Two (readonly)")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "true-type": "success",
      "false-type": "danger"
    },
    model: {
      value: (_vm.three),
      callback: function($$v) {
        _vm.three = $$v
      },
      expression: "three"
    }
  }, [_vm._v("Three")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('bs-input', {
    attrs: {
      "disabled": !_vm.input,
      "placeholder": "Will be cleaned when is disabled."
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }, [_c('span', {
    staticClass: "input-group-btn",
    slot: "before"
  }, [_c('toggle-button', {
    on: {
      "disabled": function($event) {
        _vm.content = ''
      }
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  }, [_vm._v("Toggle Input:")])], 1)])], 1), _vm._v(" "), _c('p', [_c('pre', [_vm._v("Toggle values: " + _vm._s(_vm.$data))])])]), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <toggle-button v-model=\"one\">One</toggle-button>\n    <toggle-button v-model=\"two\">Two</toggle-button>\n    <toggle-button v-model=\"two\" true-type=\"info\" disabled>Two (disabled)</toggle-button>\n    <toggle-button v-model=\"two\" false-type=\"warning\" readonly>Two (readonly)</toggle-button>\n    <toggle-button v-model=\"three\" true-type=\"success\" false-type=\"danger\">Three</toggle-button>\n    <bs-input v-model=\"content\" :disabled=\"!input\" placeholder=\"Will be cleaned when is disabled.\">\n      <span slot=\"before\" class=\"input-group-btn\">\n        <toggle-button v-model=\"input\" @disabled=\"content=''\">Toggle Input:</toggle-button>\n      </span>\n    </bs-input>\n  ")]), _vm._v(" "), _c('doc-table', [_c('div', [_c('p', [_vm._v("value")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Mixed")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("Handle the selected value.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("true-type")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(", one of "), _c('code', [_vm._v("default")]), _vm._v(" "), _c('code', [_vm._v("primary")]), _vm._v(" "), _c('code', [_vm._v("danger")]), _vm._v(" "), _c('code', [_vm._v("info")]), _vm._v(" "), _c('code', [_vm._v("warning")]), _vm._v(" "), _c('code', [_vm._v("success")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("primary")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("false-type")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(", one of "), _c('code', [_vm._v("default")]), _vm._v(" "), _c('code', [_vm._v("primary")]), _vm._v(" "), _c('code', [_vm._v("danger")]), _vm._v(" "), _c('code', [_vm._v("info")]), _vm._v(" "), _c('code', [_vm._v("warning")]), _vm._v(" "), _c('code', [_vm._v("success")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("default")])]), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('doc-table', {
    attrs: {
      "type": "Events"
    }
  }, [_c('div', [_c('p', [_vm._v("changed")]), _vm._v(" "), _c('p', [_vm._v("("), _c('code', [_vm._v("value:boolean")]), _vm._v(")")]), _vm._v(" "), _c('p', [_vm._v("If changed, return the actual state.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("disabled")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("Call this event if the button was disabled.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("enabled")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("Call this event if the button was enabled.")])])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a040b29", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a040b29!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/toggleButtonDocs.vue
// module id = 277
// module chunks = 0